<template>
  <div id="fileTableContainer">
    <el-upload
      ref="gentlyUpload"
      :show-file-list="false"
      :http-request="httpRequest"
      :accept="accept"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
      :file-list="fileList"
      action="/"
      style="height: 0"
    >
      <el-button id="gentlyBtn" size="medium" style="display: none"> 轻量化 </el-button>
    </el-upload>
    <div class="fileTable">
      <el-table
        ref="multipleTable"
        :key="keyone"
        :data="sortFileList"
        :cell-style="cellStyle"
        :row-style="rowStyle"
        :header-cell-style="headerStyle"
        tooltip-effect="dark"
        height="100%"
        row-key='folderId'
        @row-click="clickRow"
        @selection-change="selectChange"
      >
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000">暂无数据</p>
        </template>
        <el-table-column v-if="!isRecycle" type="selection" width="55" align="center" reserve-selection > </el-table-column>

        <el-table-column ref="fileNameSort" show-overflow-tooltip align="left" min-width="300px" label="文件名称" prop="folderName" >
          <template slot-scope="{ row, $index }">
            <div style="display: flex; align-items: center">
              <fileLightFlag :row="row" @updateLight="updateLight" />
              <img
                :src="className(row)"
                style=" flex-shrink: 0; margin-right: 6px; -webkit-user-drag: none; -moz-user-select: none; -ms-user-select: none; -khtml-user-select: none; user-select: none; "
              />
              <div v-if="isShowRechristen[$index]" class="rechristen name__container">
                <el-input :ref="'input' + row.folderId" v-model="rechristenCommitName" @keyup.enter.native="commit(row)" style="width: 60%"  @blur="blur"></el-input>
                <el-button type="primary" style="margin-left: 5px" size="small" @click.stop="commit(row)" > 确定 </el-button>
                <el-button style="margin-left: 3px" size="small" @click.stop="isShowRechristen = []" > 取消 </el-button>
              </div>
              <div class="name__container"
                v-else
                :style="{
                  cursor:
                    cacheListContent.createFolder.folderId === 'recycle'
                      ? ''
                      : 'pointer',
                }"
                @click.stop="clickFolderFile(row, $event)"
              >
                <span style="width: 80%; white-space: pre;">{{ row.folderName }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <div v-if="!isRecycle" class="more">
              <i v-if="scope.row.isRead !== 0 && shareXtDesign && !isArchive" class="el el-icon-share rowIcon" title="分享" @click.stop="batchShare(scope.row)" ></i>
              <i v-if="downShow(scope)" class="el el-icon-download rowIcon" title="下载" @click.stop="downloadFile(scope.row)" ></i>
              <i v-if="scope.row.isRead !== 0 && attributeXtDesign" class="el el-icon-info rowIcon" title="属性" @click.stop="showProperty(scope.row)" ></i>
              <div v-if="gengduoShow(scope) && !isArchive" style="display: inline-block" @click.stop.prevent >
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    <i class="el el-icon-more rowIcon" title="更多"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="moveShow(scope.row) && scope.row.folderArea !== '2'" :command="beforeHandleCommand(scope.row, 'move')" > 移动到 </el-dropdown-item>
                    <el-dropdown-item v-if="downShow(scope) && scope.row.folderArea !== '2'" :command="beforeHandleCommand(scope.row, 'copy')" > 复制到 </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        deleXtDesign &&
                        scope.row.isSys === 0 &&
                        scope.row.fileDel === 1 &&
                        scope.row.folderType !== 14
                      "
                      :command="beforeHandleCommand(scope.row, 'delete')"
                    >
                      删除
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        scope.row.isSys === 0 &&
                        scope.row.priviAll === 1 &&
                        scope.row.folderType !== 14
                      "
                      :command="beforeHandleCommand(scope, 'rename')"
                    >
                      重命名
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="scope.row.isPriviSet === 1"
                      :command="beforeHandleCommand(scope.row, 'management')"
                    >
                      权限管理
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-if="isRecycle" class="more">
              <i
                class="el el-icon-delete rowIcon"
                title="删除"
                @click.stop="thoroughDeleteOrRecover(scope.row, 1)"
              ></i>
              <i
                class="el-icon-refresh-left rowIcon"
                title="恢复"
                @click.stop="thoroughDeleteOrRecover(scope.row, 2)"
              ></i>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-if="isShare === 0"
          :formatter="formatterFileSize"
          prop="fileSize"
          align="center"
          width="100"
          label="文件大小"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="isShare === 1"
          :formatter="formatterFileSize2"
          prop="fileSize"
          align="center"
          width="100"
          label="文件大小"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="isShare === 1"
          prop="operDate"
          align="center"
          width="160"
          :sortable="true"
          label="删除时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="isShare === 1"
          prop="delUser"
          align="center"
          width="120"
          label="删除人"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- isShare 前台自己加的 区分是不是回收站 isShare 1 是回收站-->
        <el-table-column
          v-if="isShare === 0"
          :formatter="checkInUser"
          :sort-method="fileSizeSort"
          prop="person"
          align="center"
          width="80"
          label="修改人"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="isShare === 0"
          ref="upTimeSort"
          width="160"
          prop="checkInDate"
          align="center"
          label="修改时间"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span>{{
              row.checkInDate === "1900-01-01 00:00:00" ? "" : row.checkInDate
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <property v-if="propertyObj.folderId" :isArchive="isArchive"></property>
    <div class="model">
      <modelDialog v-if="isModelDialog"></modelDialog>
    </div>
    <share v-if="isShowShare" :type="1" @click-event="cancelSelect"></share>
    <!-- 权限管理 -->
    <document-permission
      v-if="documentShow"
      ref="documentPermission"
      :message="currentRow"
    ></document-permission>
    <!-- 移动 复制 -->
    <moveCopy
      v-if="moveCopyShow"
      ref="moveCopy"
      :type="1"
      :title="moveCopyTitle"
      :message="moveCopyRow"
    ></moveCopy>
    <!-- 轻量化提示 -->
    <LightweightReminder
      ref="LightweightReminder"
      @lightweight="lightweight"
    ></LightweightReminder>
  </div>
</template>

<script>
import { mapState } from "vuex";
import property from "./property";
import documentPermission from "@/commonComponents/documentPermission/index.vue";
import moveCopy from "@/commonComponents/documentRelevant/moveCopy.vue";
import share from "@/commonComponents/documentRelevant/shareFile.vue";
import modelDialog from "./modelDialog/modelDialog";
import { noLabelFilePreview, tableRowIcon } from "@/commonUtils/docPublic";
import docService from "@/commonService/doc-service";
import { downloadFile, downloadUrltoken } from "@/commonUtils";
import { getToken } from "@/commonUtils";
import fileLightFlag from "@/commonComponents/fileLightFlag";
import { checkPermission } from "@/commonUtils/routeAuth";
import LightweightReminder from "./modelDialog/LightweightReminder.vue";
import fileLight from "@/utils/fileLight";

export default {
  components: {
    property,
    share,
    modelDialog,
    documentPermission,
    moveCopy,
    fileLightFlag,
    LightweightReminder,
  },
  data() {
    return {
      rechristenCommitName: "",
      isShowRechristen: [],
      cacheListContent: {
        createFolder: {},
      },
      Token: {
        Token: getToken(),
      },
      actionUrl: "",
      accept: "",
      qinglianghuaList: [],
      fileList: [],
      zanwu: require("@/commonAssets/暂无数据.png"),
      keyone: 1,
      scopea: {},
      documentShow: false,
      moveCopyShow: false,
      currentRow: {},
      moveCopyRow: {},
      addXtDesign: checkPermission(":XtDesign:add"),
      uploadXtDesign: checkPermission(":XtDesign:upload"),
      downDesign: checkPermission(":XtDesign:down"),
      shareXtDesign: checkPermission(":XtDesign:share"),
      deleXtDesign: checkPermission(":XtDesign:dele"),
      attributeXtDesign: checkPermission("XtDesign:attribute"),
      moveCopyTitle: "",
      proptype: "",
      Array: [],
      checkRowType: 0,
      checkRow: null,
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.XtDesign.listArr,
      prjInfo: (state) => state.projectMg.prjObj,
      propertyObj: (state) => state.XtDesign.propertyObj,
      isShowShare: (state) => state.XtDesign.isShowShare,
      currentNode: (state) => state.XtDesign.currentTreeNode,
      searchStatus: (state) => state.XtDesign.searchStatus,
      refreshSelectArr: (state) => state.XtDesign.refreshSelectArr,
      selectArr: (state) => state.XtDesign.selectArr,
      movetoshow: (state) => state.XtDesign.movetoshow,
      integrationModel: (state) => state.XtDesign.integrationModel,
      isModelDialog: (state) => state.XtDesign.isModelDialog,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      sortObj: (state) => state.XtDesign.sortDataObj,
      timerKey: (state) => state.XtDesign.timerKey,
      userInfo: (state) => state.user.userInfo,
      zipList : (state) => state.zip.zipList,
      navArr: state => state.XtDesign.navArr,
    }),
    sortFileList() {
      if (!this.isRecycle) {
        const list = this.list;
        const arr1 = list.filter((item) => item.isSys === 1 && item.isFolder === 1);
        const arr2 = list.filter((item) => item.isSys !== 1 && item.isFolder === 1);
        const arr3 = list.filter((item) => item.isFolder !== 1);
        return [...arr1, ...arr2, ...arr3];
      } else {
        return this.list;
      }
    },
    isRecycle() {
      let { data } = this.currentNode;
      data = data || {};
      return data.folderId ? data.folderId === "recycle" : false;
    },
    isShare() {
      let data = this.list[0];
      data = data || {};
      if (data.isrecycle === true) {
        return 1;
      } else {
        return 0;
      }
    },
    isArchive() {
      return this.navArr&&this.navArr[0]?.folderType == 2
    }
  },
  watch: {
    currentNode() {
      this.keyone += 1;
    },
    sortObj() {
      this.sortChange();
    },
    timerKey() {
      this.sortChange();
    },
  },
  created() {
    // 默认为名称升序
    const obj = { prop: "fileNameSort", order: "ascending" };
    this.$store.dispatch("XtDesignSortData", obj);
  },
  methods: {
    blur() {
      setTimeout(() => {
        this.isShowRechristen = [];
      }, 500);
    },
    // 判断三个点的显示
    gengduoShow(row) {
      const down =
        this.downDesign &&
        row.row.isRead === 2 &&
        row.row.folderType !== 14 &&
        row.row.folderArea !== "2"; // 有移动
      const isdelete =
        this.deleXtDesign &&
        row.row.fileDel === 1 &&
        row.row.folderType !== 14 &&
        row.row.isSys === 0; // 有删除
      const isRename =
        row.row.isSys === 0 &&
        row.row.folderType !== 14 &&
        row.row.priviAll === 1; // 有重命名
      return isdelete || isRename || row.row.isPriviSet === 1 || down;
    },
    // 判断是否有移动权限
    moveShow(row) {
      const down = this.downDesign && row.isRead === 2 && row.folderType !== 14;
      const isdelete =
        this.deleXtDesign &&
        row.fileDel === 1 &&
        row.folderType !== 14 &&
        row.isSys === 0;
      return isdelete && down;
    },
    // 判断有下载权限
    downShow(row) {
      return (
        this.downDesign && row.row.isRead === 2 && row.row.folderType !== 14
      );
    },
    sortChange() {
      const { prop } = this.sortObj;
      const name=prop==='fileNameSort'?'folderName':prop
      this.proptype = name;
    },
    // 正序倒序方法
    my_desc_sort(a, b) {
      return (b[this.proptype] || "").localeCompare(a[this.proptype]);
    },
    my_asc_sort(a, b) {
      return (a[this.proptype] || "").localeCompare(b[this.proptype]);
    },
    my_desctype(a, b) {
      return b[this.proptype] - a[this.proptype];
    },
    my_asctype(a, b) {
      return a[this.proptype] - b[this.proptype];
    },
    async httpRequest({ file }) {
      const data = new FormData();
      data.append("file", file);
      data.append("fileId", this.scopea.row.folderId);
      data.append("fileVersion", this.scopea.row.fileVersion);
      const res = await docService.lightuploadLightFile(data);
      if (res.result === "0") {
        this.$message.success("文件轻量化成功");
      } else {
        this.$message.success("轻量化失败,请重新轻量化");
      }
    },
    cancelSelect() {
      this.$refs.multipleTable.clearSelection();
    },
    batchShare(row) {
      this.$store.dispatch("XtDesignUpdateSelect", [row]);
      this.$store.dispatch("XtDesignIsShowShare");
    },
    beforeHandleCommand(row, command) {
      return { row: row, command: command };
    },
    handleCommand(command) {
      switch (command.command) {
        case "delete": // 删除
          this.deleteRow(command.row);
          break;
        case "rename": // 重命名
          this.rechristen(command.row);
          break;
        case "management": // 权限管理
          this.managementCommand(command.row);
          break;
        case "move": // 移动
          this.moveCommand(command.row);
          break;
        case "copy": // 复制
          this.copyCommand(command.row);
          break;
      }
    },
    managementCommand(row) {
      this.currentRow = row;
      this.documentShow = true;
      this.$nextTick(() => {
        this.$refs.documentPermission.showDialog();
      });
    },
    moveCommand(row) {
      this.moveCopyTitle = "移动到";
      this.moveCopyRow = row;
      this.moveCopyShow = true;
      this.$nextTick(() => {
        this.$refs.moveCopy.showCopyDialog();
      });
    },
    copyCommand(row) {
      this.moveCopyTitle = "复制到";
      this.moveCopyRow = row;
      this.moveCopyShow = true;
      this.$nextTick(() => {
        this.$refs.moveCopy.showCopyDialog();
      });
    },
    async clickFolderFile(row, event) {
      if (row.delPrivi) return; // 回收站文件文件夹
      const { isFolder } = row;
      if (isFolder === 1) {
        if (!this.searchStatus) {
          this.$store.dispatch("XtDesignOpenNodeFolder", row);
        } else {
          this.$store.dispatch("XtDesignUpdateSearchRow", { ...row });
        }
      } else {
        if (isFolder === 1) return;
        this.viewFile(row, event);
      }
    },

    async viewFile(row, event) {
      this.onLineView(row);
    },

    async onLineView(row) {
      const { prjId, prjName } = this.prjInfo;
      noLabelFilePreview(row, prjId, prjName, "ct", "");
    },

    async downloadFile(row) {
      if(this.zipList&&this.zipList.length>0) return this.$message.warning('有正在压缩等待下载的文件夹，请稍等')
      const prjId = this.prjInfo.prjId;
      const userInfo = this.userInfo;
      const { userId, token } = userInfo;
      if (row.isFolder !== 1) {
        const fileId = row.folderId;
        const downzipurl = downloadUrltoken(prjId, fileId, row.fileVersion);
        downloadFile(downzipurl);
      } else {
        var params = {
          folderId: row.folderId,
          rootDirectory: row.folderName,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId,
        };
        let zipItem = {
          name: row.folderName + ".zip",
          percent: 0,
          success: false,
        };
        this.$store.dispatch("pushZip", zipItem);
        docService
          .downloadfolder(params, (percentage) => {
            zipItem.percent = percentage;
          })
          .then((response) => {
            const fileName = row.folderName + ".zip";
            zipItem.success = true;
            this.$store.dispatch("refreshZip");
            if ("msSaveOrOpenBlob" in navigator) {
              window.navigator.msSaveOrOpenBlob(response, fileName);
              return;
            } else {
              const link = document.createElement("a");
              const blob = response;
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              link.setAttribute("download", decodeURI(fileName));
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          });
      }
    },

    async rechristen({ $index, row }) {
      this.isShowRechristen = [];
      if (row.isFolder === 1) {
        this.rechristenCommitName = row.folderName;
      } else {
        const typeIndex = row.folderName.lastIndexOf(".");
        const newName = row.folderName.substring(0, typeIndex);
        this.rechristenCommitName = newName;
      }
      this.isShowRechristen[$index] = true;
      this.$set(this.isShowRechristen, $index, true);
      this.$nextTick(() => {
        const ref = "input" + row.folderId;
        this.$refs[ref].focus();
      });
    },

    async commit(row) {
      // let name = this.rechristenCommitName.replace(/\s*/g, "");
      let name = this.rechristenCommitName?.trim?.();
      if (!name || name.length < 1 || name.length > 80) {
        return this.$message.warning("名字不能为空且不超过80个字符");
      }
      const { isFolder, parentId } = row;
      var id = row.folderId;
      const prjId = this.prjInfo.prjId;
      var remark = "";
      if (row.isFolder === 0) {
        const fileTypeArr = row.folderName.split(".");
        name = `${name}.${fileTypeArr[fileTypeArr.length - 1]}`;
      }
      try {
        const result = await docService.queryRechristen({
          name,
          id,
          remark,
          isFolder,
          prjId,
          parentId,
        });
        if (result.result === "0") {
          await this.$store.dispatch("XtDesignUpdateNodeList");
          this.isShowRechristen = [];
          this.$message.success("修改成功");
          row.folderName = name;
        }
      } catch (e) {
        // this.$message.warning(e.message || '修改失败')
      }
    },

    updateLight(row, type, isSuccess) {
      this.checkRow = row;
      this.checkRowType = type;
      if (isSuccess) {
        let lightweightReminder =
          JSON.parse(localStorage.getItem("lightweightReminder")) || false;
        if (!lightweightReminder) {
          this.$refs.LightweightReminder.lightweightReminder =
            JSON.parse(localStorage.getItem("lightweightReminder")) || false;
          this.$refs.LightweightReminder.uploadDialog = true;
          return;
        }
      }
      this.lightweight();
    },
    // 轻量化
    lightweight() {
      const { prjId } = this.prjInfo;
      // this.checkRow.status = "1";
     fileLight.setDealing(this.checkRow)
      const status = this.checkRow.status;
      let messageType;
      this.checkRowType === 1
        ? (messageType = "优先轻量化操作")
        : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, this.checkRow.folderId, this.checkRow.fileVersion)
        .then((res) => {
          if (res.result === "0") {
            // this.checkRow.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            this.checkRow.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          this.checkRow.status = status;
          // this.$message.warning(`${messageType}失败`)
        });
    },

    handleBeforeUpload(file) {
      const lastObj = this.qinglianghuaList[this.qinglianghuaList.length - 1];
      const uploadFileName = this._splitFileName(file.name);
      const rvtFileName = this._splitFileName(lastObj.folderName);
      if (uploadFileName !== rvtFileName) {
        this.$message({
          message: `请选择和${
            lastObj.fileType === 7 ? "rvt" : "skp"
          }文件匹配的轻量化文件`,
          type: "warning",
          duration: 2000,
          showClose: true,
        });
        return false;
      }
      lastObj.status = "1";
      this.$message.success("操作成功,正在轻量化");
    },

    _splitFileName(text) {
      const pattern = /\.{1}[a-zA-Z]{1,}$/;
      if (pattern.exec(text) !== null) {
        return text.slice(0, pattern.exec(text).index);
      } else {
        return text;
      }
    },

    _splitFileType(text) {
      const lastIndex = text.lastIndexOf(".");
      return text.substring(lastIndex + 1);
    },

    handleError() {
      this.$message({
        message: "文件轻量化失败,请重新轻量化",
        type: "warning",
        duration: 2000,
        showClose: true,
      });
    },

    showProperty(row) {
      this.$store.dispatch("XtDesignIsShowProperty", row);
    },

    async deleteRow(row) {
      const folderId = row.folderId;
      try {
        this.$confirm("确定删除吗?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.$store.dispatch("XtDesignUpdateMessageObj", {
              isShow: true,
              message: "删除中...",
            });
            const result = await docService.queryDeleteFile([folderId]);
            if (result.result === "0") {
              await this.$store.dispatch("XtDesignDelListRow", [folderId]);
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: "",
              });
              this.$message({ type: "success", message: "删除成功" });
            }
          })
          .catch(() => {});
      } catch (e) {
        this.$store.dispatch("XtDesignUpdateMessageObj", {
          isShow: false,
          message: "",
        });
      }
    },

    async thoroughDeleteOrRecover(row, type) {
      let messageType = "";
      type === 1 ? (messageType = "删除") : (messageType = "恢复");
      this.$store.dispatch("XtDesignUpdateMessageObj", {
        isShow: true,
        message: `${messageType}中...`,
      });
      try {
        if (messageType === "删除") {
          this.$confirm("是否确定删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              var fileIds = [];
              var folderIds = [];
              if (row.folderType === 1) {
                fileIds.push(row.folderId);
              } else {
                folderIds.push(row.folderId);
              }
              const result = await docService.recycldelete({
                fileIds,
                folderIds,
              });
              if (result.result === "0") {
                await this.$store.dispatch("XtDesignDelListRow", [
                  row.folderId,
                ]);
                this.$store.dispatch("XtDesignUpdateMessageObj", {
                  isShow: false,
                  message: "",
                });
                this.$message.success(`${messageType}成功`);
              }
            })
            .catch(() => {
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: "",
              });
            });
        } else {
          // 恢复
          var fileIds = [];
          var folderIds = [];
          if (row.folderType === 1) {
            fileIds.push(row.folderId);
          } else {
            folderIds.push(row.folderId);
          }
          const result = await docService.recyclerestore({
            fileIds,
            folderIds,
          });
          if (result.result === "0") {
            await this.$store.dispatch("XtDesignDelListRow", [row.folderId]);
            this.$store.dispatch("XtDesignUpdateMessageObj", {
              isShow: false,
              message: "",
            });
            this.$message.success(`${messageType}成功`);
          }
        }
      } catch (e) {
        this.$store.dispatch("XtDesignUpdateMessageObj", {
          isShow: false,
          message: "",
        });
      }
    },

    renderRowDelAuthFunc(row) {
      // isSys=1是系统文件夹
      // isSys=0自建文件夹(上传的或者是新建的)
      return row.isSys === 0;
    },

    clickRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    // 勾选事件
    async selectChange(selection) {
      this.$store.dispatch("XtDesignUpdateSelect", selection);
      this.$store.dispatch("XtDesignIntegrationModel", selection);
    },

    formatterFileSize(row, column) {
      if (row.isFolder === 0) {
        return row.fileSize;
      }
    },
    formatterFileSize2(row, column) {
      if (row.folderType !== 0) {
        return row.fileSize;
      }
    },

    checkInUser(row, column) {
      return row.checkInUser;
    },

    fileSizeSort(obj1, obj2) {
      return obj1.checkInUser.localeCompare(obj2.checkInUser, "zh");
    },

    className(row) {
      return tableRowIcon(row);
    },

    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;height:54px;padding:0px;border-top:1px solid #EFF0F9";
    },

    rowStyle() {
      return "height:60px;padding:0px";
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return "height:60px";
    },
  },
};
</script>

<style lang="scss">
.el-dropdown-menu {
  .el-dropdown-menu__item {
    text-align: center;
  }
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
#fileTableContainer {
  width: 100%;
  background-color: #fff;
  height: calc(100% - 140px);
  /deep/ .name__container {
    flex-grow: 1;
    min-width: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .fileTable {
    width: 100%;
    min-width: 100px;
    height: 100%;
    overflow: auto;
    padding: 0px 26px;
  }

  /deep/ .el-table {
    .el-table__header-wrapper {
      height: 54x;
      display: flex;
      align-items: center;
    }

    .el-table__body-wrapper {
      .rowIcon {
        cursor: pointer;
        color: #A8AECE;
        font-size: 16px;
        margin-right: 6px;
      }

      .rowIcon:hover {
        color: #3873FE;
      }
    }

    .el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: rgb(255, 255, 255);
      border-radius: 2px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 10px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #C4C6CC;
    }
  }
}
</style>
